import * as $ from 'jquery';
import {onClick, onLoad} from 'Core/Events';
import "slick-carousel";
import { preventClick } from './CommonFunctions';
import BlazeSlider from "blaze-slider";
import { ActualScreen, Breakpoints, getActualScreen } from 'Core/Responsiveness';
import { createSlickChevron } from './SlickChevron';

export const Homepage = (() => {

    const Selector = {
        SLIDER_SLIDE: '.main-slider-slide',
        SLIDER_IMAGE: '.main-slider-image',
        BANER_BAR: '.baner_bar', //suitable for newsletter bar and top page baner
        BANNER_CONTAINER: '.js_banner_carousel',
        BANNER_FIRST_IMAGE: '.main-slider-first',
        ICONS_CONTAINER: '.js_promo_carousel',
        HIDDEN_IMAGES: '.js_hidden',
        TAB_NAVS: '.products-tagged-slider .nav-item',
        TAB_ITEMS: '.tab-item',
        SLIDE_WITHOUT_LINK: '.no-click-slide',
        SEO_SECTION: '.homepage-seo-section-footer',
        SEO_SECTION_BTN: '.homepage-seo-section-button',
        NAVIGATION_PANEL_SLIDER: '.js_navigation_panel_slider',
    };

    onLoad(() => banerBarHandler(Selector.BANER_BAR));
    onLoad(initBanner);
    onLoad(iconsSlider);
    onLoad(initNavigationPanelSlider);
    onLoad(loadImages);
    onClick(Selector.TAB_NAVS, openTabHandler);
    onClick(Selector.SLIDE_WITHOUT_LINK, preventClick); //prevent to click to slide without link
    onClick(Selector.SEO_SECTION_BTN, showAllSeoTextsInSection)

    function banerBarHandler(slideElement) {
        $(slideElement).each(function (index, element) {
    
            if($(element).hasClass('slider')) {
                makeSliderImage(element); //for main slider
            } else {
                const image = getImageFromData(element)
                setSliderParams(element, 'background-image', `url(${image})`)
				$(element).css('background-position', 'center');
				$(element).css('background-position', 'center');
				$(element).css('background-size', 'cover');
            }
        });
    }


    function makeSliderImage(current) { //prepare image for slider
        const $this = $(current).find(Selector.SLIDER_IMAGE);
        const image = getImageFromData($this)
        setSliderParams($this, 'background-image', `url(${image})`)
    }

    function getImageFromData(target: JQuery<HTMLElement>): string { //get image address from data param
        return $(target).data('image');
    }

    function setSliderParams(target, attr, value) { //set values dynamiclly on slider elements
        $(target).css(attr, value);
        $(target).removeClass('notLoaded');
    }

    function initBanner() {
        if ($(Selector.BANNER_CONTAINER).length) {
            $(Selector.BANNER_CONTAINER).slick({
                arrows: false,
                dots: true,
                speed: 1000,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                rows: 0,
                cssEase: 'cubic-bezier(0.600, -0.280, 0.735, 0.045)',
            });
            $(Selector.BANNER_CONTAINER).parent().css('height','auto');
            $(Selector.BANNER_CONTAINER).fadeIn();
        }
    }

    function iconsSlider() {
        if ($(Selector.ICONS_CONTAINER).length) {
            $(Selector.ICONS_CONTAINER).slick({
                infinite: false,
                arrows: true,
                dots: false,
                adaptiveHeight: true,
                slidesToShow: 6,
                slidesToScroll: 1,
                rows: 0,
                prevArrow: createSlickChevron('prev', 'poprzednie cechy'),
                nextArrow: createSlickChevron('next', 'następne cechy'),
                responsive: [
                    {
                        breakpoint: 1100,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 2,
                        },
                    },
                    {
                        breakpoint: 500,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 2,
                        },
                    }
                ]
            });
        }
    }

    function loadImages() {
        if ($(Selector.HIDDEN_IMAGES).hasClass('d-none')) {
            $(Selector.HIDDEN_IMAGES).removeClass('d-none')
        }
    }

    function openTabHandler() { // open tab with slider
        $(this).css('pointer-events', 'none')
        const navTarget = $(this).find('.nav-link').data('url');
        const navItems = $(Selector.TAB_ITEMS);
        hideAllElements(navItems); //hide tab with sliders
        openSpecTab(navTarget); //open choosen slider
        activeNavToggle($(this)); //give active class to choosen nav element
    }

    function hideAllElements(elements) { //hide other tab with sliders
        $(elements).each((i, el) => {
            $(el).hide();
            clearVisibleClass(el); //delete is-visible class from tab slider
        })
    }

    function clearVisibleClass(element) {
        $(element).find('.js_common_products_carousel').removeClass('is-visible')
    }

    function openSpecTab(target) { //open specific tab with slider and give controler is-visible class
        $(target).fadeIn('slow');
        $(target).find('.js_common_products_carousel').addClass('is-visible').slick('setPosition');;
    }

    function activeNavToggle(element) {
        takeDownActive(element); //remove active class from current nav element
        $(element).find('.nav-link').addClass('active');

        setTimeout(function () { // prevent to double click on slider navigation - double click make slick setPosition broken
            $(element).css('pointer-events', 'auto')
        }, 500)
    }

    function takeDownActive(element) { //remove active class from current nav element
        $(element).parent().find('.nav-link.active').removeClass('active');
    }

    function showAllSeoTextsInSection(e){
         e.preventDefault();
         let firstChild = $(Selector.SEO_SECTION).children().first();
         let allChilds = $(Selector.SEO_SECTION).children();
         if (firstChild.hasClass('d-block')) {
             allChilds.removeClass('d-block');
             $(Selector.SEO_SECTION_BTN).text("Czytaj więcej");
         } else {
             allChilds.addClass('d-block');
             $(Selector.SEO_SECTION_BTN).text("Czytaj mniej");
         }
     }

      function initNavigationPanelSlider() {
           if ($(Selector.NAVIGATION_PANEL_SLIDER).length && ActualScreen.WIDTH < Breakpoints.MD) {
               new BlazeSlider($(Selector.NAVIGATION_PANEL_SLIDER)[0], {
                   all: {
                       slidesToShow: 1,
                       slidesToScroll: 1,
                       loop: true,
                       enablePagination: true,
                   },
               });
           }
       }

})();
import * as $ from 'jquery';
import {onClick, onLoad} from 'Core/Events';
import "slick-carousel";
import { preventClick } from './CommonFunctions';
import BlazeSlider from "blaze-slider";
import { ActualScreen, Breakpoints, getActualScreen } from 'Core/Responsiveness';
import { createSlickChevron } from './SlickChevron';

export const Homepage = (() => {

    const Selector = {
        SLIDER_SLIDE: '.main-slider-slide',
        SLIDER_IMAGE: '.main-slider-image',
        BANER_BAR: '.baner_bar', //suitable for newsletter bar and top page baner
        BANNER_CONTAINER: '.js_banner_carousel',
        BANNER_FIRST_IMAGE: '.main-slider-first',
        ICONS_CONTAINER: '.js_promo_carousel',
        HIDDEN_IMAGES: '.js_hidden',
        TAB_NAVS: '.products-tagged-slider .nav-item',
        TAB_ITEMS: '.tab-item',
        SLIDE_WITHOUT_LINK: '.no-click-slide',
        SEO_SECTION: '.homepage-seo-section-footer',
        SEO_SECTION_BTN: '.homepage-seo-section-button',
        NAVIGATION_PANEL_SLIDER: '.js_navigation_panel_slider',
    };

    onLoad(() => banerBarHandler(Selector.BANER_BAR));
    onLoad(initBanner);
    onLoad(iconsSlider);
    onLoad(initNavigationPanelSlider);
    onLoad(loadImages);
    onClick(Selector.TAB_NAVS, openTabHandler);
    onClick(Selector.SLIDE_WITHOUT_LINK, preventClick); //prevent to click to slide without link
    onClick(Selector.SEO_SECTION_BTN, showAllSeoTextsInSection)

    function banerBarHandler(slideElement) {
        $(slideElement).each(function (index, element) {
    
            if($(element).hasClass('slider')) {
                makeSliderImage(element); //for main slider
            } else {
                const image = getImageFromData(element)
                setSliderParams(element, 'background-image', `url(${image})`)
				$(element).css('background-position', 'center');
				$(element).css('background-position', 'center');
				$(element).css('background-size', 'cover');
            }
        });
    }


    function makeSliderImage(current) { //prepare image for slider
        const $this = $(current).find(Selector.SLIDER_IMAGE);
        const image = getImageFromData($this)
        setSliderParams($this, 'background-image', `url(${image})`)
    }

    function getImageFromData(target: JQuery<HTMLElement>): string { //get image address from data param
        return $(target).data('image');
    }

    function setSliderParams(target, attr, value) { //set values dynamiclly on slider elements
        $(target).css(attr, value);
        $(target).removeClass('notLoaded');
    }

    function initBanner() {
        if ($(Selector.BANNER_CONTAINER).length) {
            $(Selector.BANNER_CONTAINER).slick({
                arrows: false,
                dots: true,
                speed: 1000,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                rows: 0,
                cssEase: 'cubic-bezier(0.600, -0.280, 0.735, 0.045)',
            });
            $(Selector.BANNER_CONTAINER).parent().css('height','auto');
            $(Selector.BANNER_CONTAINER).fadeIn();
        }
    }

    function iconsSlider() {
        if ($(Selector.ICONS_CONTAINER).length) {
            $(Selector.ICONS_CONTAINER).slick({
                infinite: false,
                arrows: true,
                dots: false,
                adaptiveHeight: true,
                slidesToShow: 6,
                slidesToScroll: 1,
                rows: 0,
                prevArrow: createSlickChevron('prev', 'poprzednie cechy'),
                nextArrow: createSlickChevron('next', 'następne cechy'),
                responsive: [
                    {
                        breakpoint: 1100,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 2,
                        },
                    },
                    {
                        breakpoint: 500,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 2,
                        },
                    }
                ]
            });
        }
    }

    function loadImages() {
        if ($(Selector.HIDDEN_IMAGES).hasClass('d-none')) {
            $(Selector.HIDDEN_IMAGES).removeClass('d-none')
        }
    }

    function openTabHandler() { // open tab with slider
        $(this).css('pointer-events', 'none')
        const navTarget = $(this).find('.nav-link').data('url');
        const navItems = $(Selector.TAB_ITEMS);
        hideAllElements(navItems); //hide tab with sliders
        openSpecTab(navTarget); //open choosen slider
        activeNavToggle($(this)); //give active class to choosen nav element
    }

    function hideAllElements(elements) { //hide other tab with sliders
        $(elements).each((i, el) => {
            $(el).hide();
            clearVisibleClass(el); //delete is-visible class from tab slider
        })
    }

    function clearVisibleClass(element) {
        $(element).find('.js_common_products_carousel').removeClass('is-visible')
    }

    function openSpecTab(target) { //open specific tab with slider and give controler is-visible class
        $(target).fadeIn('slow');
        $(target).find('.js_common_products_carousel').addClass('is-visible').slick('setPosition');;
    }

    function activeNavToggle(element) {
        takeDownActive(element); //remove active class from current nav element
        $(element).find('.nav-link').addClass('active');

        setTimeout(function () { // prevent to double click on slider navigation - double click make slick setPosition broken
            $(element).css('pointer-events', 'auto')
        }, 500)
    }

    function takeDownActive(element) { //remove active class from current nav element
        $(element).parent().find('.nav-link.active').removeClass('active');
    }

    function showAllSeoTextsInSection(e){
         e.preventDefault();
         let firstChild = $(Selector.SEO_SECTION).children().first();
         let allChilds = $(Selector.SEO_SECTION).children();
         if (firstChild.hasClass('d-block')) {
             allChilds.removeClass('d-block');
             $(Selector.SEO_SECTION_BTN).text("Czytaj więcej");
         } else {
             allChilds.addClass('d-block');
             $(Selector.SEO_SECTION_BTN).text("Czytaj mniej");
         }
     }

      function initNavigationPanelSlider() {
           if ($(Selector.NAVIGATION_PANEL_SLIDER).length && ActualScreen.WIDTH < Breakpoints.MD) {
               new BlazeSlider($(Selector.NAVIGATION_PANEL_SLIDER)[0], {
                   all: {
                       slidesToShow: 1,
                       slidesToScroll: 1,
                       loop: true,
                       enablePagination: true,
                   },
               });
           }
       }

})();
